var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFiles = function SvgIconFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 13.5a1 1 0 0 1 1-1h4.125a1 1 0 1 1 0 2H8.25a1 1 0 0 1-1-1M8.25 16.25a1 1 0 1 0 0 2h4.125a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.875 5.375v-2a1.75 1.75 0 0 1 1.75-1.75h7.5a1 1 0 0 1 .707.293l3.75 3.75a1 1 0 0 1 .293.707V16.5a1.75 1.75 0 0 1-1.75 1.75h-2v2a1.75 1.75 0 0 1-1.75 1.75H5.25a1.75 1.75 0 0 1-1.75-1.75V7.125a1.75 1.75 0 0 1 1.75-1.75zm2 0v-1.75h6.836l3.164 3.164v9.461h-1.75v-6.125a1 1 0 0 0-.293-.707l-3.75-3.75a1 1 0 0 0-.707-.293zm6.25 5.164-3.164-3.164H5.5V20h9.625z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFiles;